module.exports = __webpack_public_path__ + "img/Carte-apaym-01.5c15a70d.png";